import { render, staticRenderFns } from "./warp.vue?vue&type=template&id=810bae78"
import script from "./warp.vue?vue&type=script&lang=js"
export * from "./warp.vue?vue&type=script&lang=js"
import style0 from "./warp.vue?vue&type=style&index=0&id=810bae78&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('810bae78')) {
      api.createRecord('810bae78', component.options)
    } else {
      api.reload('810bae78', component.options)
    }
    module.hot.accept("./warp.vue?vue&type=template&id=810bae78", function () {
      api.rerender('810bae78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/teacherMatch/warp.vue"
export default component.exports